// @generated by protoc-gen-es v1.10.1 with parameter "target=dts+js"
// @generated from file agent/livekit_agent_dev.proto (package livekit.agent, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * AgentDevMessage is used for IPC between the CLI and agent processes
 * during dev-mode hot reload.
 *
 * @generated from message livekit.agent.AgentDevMessage
 */
export const AgentDevMessage = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.AgentDevMessage",
  () => [
    { no: 1, name: "get_running_jobs_request", kind: "message", T: GetRunningAgentJobsRequest, oneof: "message" },
    { no: 2, name: "get_running_jobs_response", kind: "message", T: GetRunningAgentJobsResponse, oneof: "message" },
  ],
);

/**
 * @generated from message livekit.agent.GetRunningAgentJobsRequest
 */
export const GetRunningAgentJobsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.GetRunningAgentJobsRequest",
  [],
);

/**
 * @generated from message livekit.agent.GetRunningAgentJobsResponse
 */
export const GetRunningAgentJobsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.GetRunningAgentJobsResponse",
  () => [
    { no: 1, name: "jobs", kind: "message", T: RunningAgentJobInfo, repeated: true },
  ],
);

/**
 * @generated from message livekit.agent.RunningAgentJobInfo
 */
export const RunningAgentJobInfo = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.RunningAgentJobInfo",
  () => [
    { no: 1, name: "job", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "accept_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "accept_identity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "accept_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "worker_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "mock_job", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

